import React from 'react';
import ReactDOM from 'react-dom/client'; 
import { socket, SocketContext } from './utils/socket';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from "./authProvider";
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
      <BrowserRouter>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}> 
          <SocketContext.Provider value={socket}>
            <App />
          </SocketContext.Provider>
        </MsalProvider> 
      </React.StrictMode>
      </BrowserRouter>
);



